module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(!_vm.first) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.section.heading || _vm.section.body) ? _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.section.heading) ? _c('h2', {
    staticClass: "static-info--sub-heading",
    domProps: {
      "innerHTML": _vm._s(_vm.section.heading)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.section.body) ? _c('p', {
    staticClass: "static-info--sub-teaser",
    domProps: {
      "innerHTML": _vm._s(_vm.section.body)
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.previewSection) ? [_c('sk-layout', {
    staticClass: "management__content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "md2": ""
    }
  }, [_c('div', {
    staticClass: "management__image"
  }, [_c('img', {
    attrs: {
      "src": _vm.previewSection.person_image.url
    }
  })])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "md10": ""
    }
  }, [_c('h6', {
    staticClass: "management__person-name",
    domProps: {
      "innerHTML": _vm._s(_vm.previewSection.title)
    }
  }), _vm._v(" "), (_vm.previewSection.position) ? _c('span', {
    staticClass: "management__job-description",
    domProps: {
      "innerHTML": _vm._s(_vm.previewSection.position)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "management__summary"
  }, [_c('p', [_vm._v(_vm._s(_vm.previewSection.person_description))])])])], 1)] : _vm._e(), _vm._v(" "), _vm._l((_vm.page_content), function(person, index) {
    return [(index != 0 || _vm.previewSection) ? _c('hr') : _vm._e(), _vm._v(" "), _c('sk-layout', {
      staticClass: "management__content",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "md2": ""
      }
    }, [_c('div', {
      staticClass: "management__image"
    }, [_c('img', {
      attrs: {
        "src": person.person_image.url
      }
    })])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "md10": ""
      }
    }, [_c('h6', {
      staticClass: "management__person-name",
      domProps: {
        "innerHTML": _vm._s(person.title)
      }
    }), _vm._v(" "), (person.position) ? _c('span', {
      staticClass: "management__job-description",
      domProps: {
        "innerHTML": _vm._s(person.position)
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "management__summary"
    }, [_c('p', [_vm._v(_vm._s(person.person_description))])])])], 1)]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06be42c6","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/person_management_team/person_management_team.vue
// module id = 643
// module chunks = 0